<template>
  <div class="extension-panel">
    <loading-icon v-if="offerLoading" :loadingIconClasses="'offer-loading'"></loading-icon>

    <div v-else class="offers-panel">
      <small v-if="loadError" class='file-warning error-label form-message'>{{loadError}}</small>

      <div v-if="currentMerchant.mywalletdeals_enabled">
        <label>offer type</label>
        <div class="offer-type">
          <label
              v-for="offer in offerOptions"
              class="offer-type-container"
              :key="offer.id"
              :for="offer.id">
            <input
              v-model="offerType"
              class="offer-type-radio"
              type="radio"
              :value="offer.value"
              :name="[referredMessaged ? 'referral_offerType'+ messageId : 'offerType'+ messageId]"
              :id="offer.id" />
            <span :class="[offer.value, 'radio radio-offer-type text-center']">
              {{ offer.label1 }}<br>{{ offer.label2 }}
            </span>
          </label>
        </div>
      </div>
      <offerForm
        :bonusType="bonusType"
        :bonusValue="bonusValue"
        :campaignSendTime="campaignSendTime"
        :expirationDate="expirationDate"
        :expiryDays="expiryDays"
        :itemName="itemName"
        :maxRedemptions="maxRedemptions"
        :rewardMeta="rewardMeta"
        :rewardType="rewardType"
        :rewardValue="rewardValue"
        :minPurchaseAmount="minPurchaseAmount"
        :offerId="offerId"
        :offerType="offerType"
        :referredMessaged="referredMessaged"
        :rewardAttachmentUploads="rewardAttachmentUploads"
        :rewardOwner="{id: messageId, type: messageType}"
        :applyToNonOptIn="applyToNonOptIn"
        :isBudzAutoCampaign="isBudzAutoCampaign"
        @updateOffer="updateOffer"
        @updateUserInteractions="updateUserInteractions"
        @validOffer="updateValidOffer"
      />
    </div>
    <div class="cancel-extension" @click="$emit('setExtension', 0)">cancel</div>
  </div>
</template>

<script>
  import axiosConfig from '../../config/axios'
  import LoadingIcon from '../shared/LoadingIcon'
  import LoadRewardMixin from '../../mixins/LoadRewardMixin'
  import { mapState } from 'vuex'
  import OfferForm from './OfferForm.vue'
  import moment from 'moment'

  export default {
    props: {
      isBudzAutoCampaign: Boolean,
      messageModuleName: String,
      referredMessaged: Boolean,
      rewardId: Number,
      campaignSendTime: String,
    },

    components: {
      OfferForm,
      LoadingIcon,
    },

    mixins: [LoadRewardMixin],

    data() {
      return {
        bonusType: '',
        bonusValue: 0,
        expirationDate: '',
        expiryDays: '',
        itemName: '',
        loadError: null,
        maxRedemptions: -1,
        minPurchaseAmount: 0,
        offerId: null,
        offerLoading: true,
        offerOptions: null,
        offerType: '',
        applyToNonOptIn: false
      }
    },

    methods: {
      setOfferOptions() {
        const messageId = this.messageId
        this.offerOptions = [
          {
            id: 'coupon-'+ messageId,
            value: 'coupon',
            label1: 'digital',
            label2: 'voucher'
          },
          {
            id: 'bonus-points-'+ messageId,
            value: 'bonus-points',
            label1: 'bonus',
            label2: 'points'
          },
          {
            id: 'instant-points-' + messageId,
            value: 'instant-points',
            label1: 'instant',
            label2: 'points'
          }
        ]
      },

      setRewardData(rewardData) {
        this.bonusType = rewardData.bonus_type
        this.bonusValue = rewardData.bonus_value
        this.expirationDate = rewardData.expiration_date ? moment(moment.utc(rewardData.expiration_date)).format("YYYY-MM-DD") : ''
        this.expiryDays = rewardData.expiry_days ? moment(rewardData.expiry_days).unix() : null
        this.itemName = rewardData.item_name
        this.loadError = null
        this.maxRedemptions = rewardData.max_redemptions
        this.minPurchaseAmount = rewardData.min_purchase_amount
        this.offerId = rewardData.id
        this.applyToNonOptIn = !!rewardData.apply_to_non_opt_in
        this.offerLoading = false
        this.offerType = rewardData.type === 'BonusReward' ? 'bonus-points' : rewardData.type === 'InstantReward' ? 'instant-points' : 'coupon'
        this.rewardMeta = rewardData.meta
        this.rewardType = rewardData.reward_type
        this.rewardValue = rewardData.reward_value
      },

      setRewardLoadError(error) {
        this.loadError = error
        if (this.offerLoading) { this.offerLoading = false }
      },

      updateOffer(dataToUpdate) {
        const url = `/api/v3/campaign_rewards/${this.offerId}`;
        const rewardData = {
          reward: dataToUpdate,
          owner_id: this.messageId,
          owner_type: this.messageType
        }
        axiosConfig.patch(url, rewardData)
          .then((response) => {
            const rewardData = response.data.reward
            if (rewardData) {
              this.setRewardData(rewardData)
            } else {
              this.loadError = 'issue updating reward'
            }
          })
          .catch((error) => {
            this.loadError = `issue updating reward. ${error}`
          })
      },

      updateUserInteractions(noInteractions) {
        const none = noInteractions ? { offers: true } : {}
        this.$emit('configOfferInteractions', none)
      },

      updateValidOffer(value) {
        this.$emit('validOffer', value)
      },
    },

    created() {
      this.offerId = this.rewardId
      this.setOfferOptions()
      this.loadReward('messageType','messageId')
    },

    computed: {
      ownerTypeDisplay: function () {
        return this.offerType === 'coupon' ? 'voucher' : this.offerType
      },

      rewardAttachmentUploads: function () {
        let attachmentsToUpload = []
        const preload = {
          differentLabel: 'preload image',
          displayType: `${this.referredMessaged ? 'referral-' : ''}preload-image-${this.offerId}`,
          instructions: 'sends with your text',
          type: 'preload',
        }
        attachmentsToUpload.push(preload)
        if (this.offerType === 'coupon') {
          let coupon = {
            differentLabel: 'voucher image',
            displayType: `${this.referredMessaged ? 'referral-' : ''}coupon-image-${this.offerId}`,
            instructions: 'displays on customer voucher',
            type: 'coupon',
          }
          attachmentsToUpload.push(coupon)
        }
        return attachmentsToUpload
      },

      ...mapState({
        currentMerchant (state) { return state.currentMerchant },
        messageId (state) { return state[this.messageModuleName]?.messageId },
        messageType (state) { return state[this.messageModuleName]?.messageType },
      })
    },

    watch: {
      offerType: function() {
        if (this.offerType === 'bonus-points') {
          this.$emit('setExtension', 5)
          this.updateOffer({ type: 'BonusReward' })
        } else if (this.offerType === 'coupon') {
          this.$emit('setExtension', 1)
          this.updateOffer({ type: null })
        } else if (this.offerType === 'instant-points') {
          this.$emit('setExtension', 6)
          this.updateOffer({ type: 'InstantReward', bonus_type: 'add', max_redemptions: 1 })
        }
      }
    }

  }
</script>
